import { Button, Card, Col, Form, Input, Row, Select, Space, TreeSelect, theme } from 'antd';
import { useEffect, useState } from 'react';
import { computeButtonColLayout, filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';
import './ChannelFilterPanel.less';

const VISIBLE_FIELD_COUNT = 4;
const TOTAL_FIELD_COUNT = 5;

export default function ChannelFilterPanel({ filter, onFinish, onReset, treeData, dataList }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [expanded, setExpanded] = useState(false);
    const buttonColLayout = computeButtonColLayout(expanded ? TOTAL_FIELD_COUNT : VISIBLE_FIELD_COUNT);

    useEffect(() => {
        form.setFieldsValue({
            title: filter.title,
            id: filter.id,
            channelType: filter.channelType,
            status: filter.status,
            createdByStaffId: filter.createdByStaffId,
        });
        if (filter.createdByStaffId !== undefined && filter.createdByStaffId !== '') {
            setExpanded(true);
        }
    }, [filter, form]);

    const handleReset = () => {
        form.resetFields();
        setExpanded(false);
        onReset();
    };

    return (
        <Card
            size="small"
            className="channel-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} form={form} onFinish={onFinish} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="关键字" name="title" style={filterFormItemStyle}>
                            <Input allowClear placeholder="渠道名称关键字" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="渠道ID" name="id" style={filterFormItemStyle}>
                            <Input allowClear placeholder="渠道ID" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="渠道分类" name="channelType" style={filterFormItemStyle}>
                            {treeData && <TreeSelect style={{ width: '100%' }} treeData={treeData} placeholder="选择渠道分类" treeDefaultExpandAll allowClear />}
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="状态" name="status" style={filterFormItemStyle}>
                            <Select allowClear placeholder="选择渠道状态">
                                <Select.Option value={0}>启用</Select.Option>
                                <Select.Option value={1}>禁用</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    {expanded && (
                        <Col {...filterFormGridLayout}>
                            <Form.Item label="创建人" name="createdByStaffId" style={filterFormItemStyle}>
                                <Select allowClear placeholder="选择创建人">
                                    {dataList?.map(item => (
                                        <Select.Option key={item.phone} value={item.phone}>
                                            {item.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    )}

                    <Col {...buttonColLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={handleReset}>
                                    重置
                                </Button>
                                <Button type="link" size="small" aria-expanded={expanded} onClick={() => setExpanded(prev => !prev)} style={{ fontSize: 12, color: token.colorTextSecondary }}>
                                    {expanded ? (
                                        <>
                                            收起 <span className="bi bi-chevron-up" aria-hidden="true" />
                                        </>
                                    ) : (
                                        <>
                                            展开 <span className="bi bi-chevron-down" aria-hidden="true" />
                                        </>
                                    )}
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
